import { useCallback } from 'react';
import { useModuleRouter } from '../../../hooks/useModuleRouter';
import { moduleNameToEnum, moduleRouteMappings } from 'utils/helpers';
import { ModuleEnum } from 'utils/enums';

const PERMISSIONS_SPECIAL_MODULES = ['Config', 'CampaignMonitor'];

const getModuleName = (moduleNameFromRoute: string) =>
  moduleNameFromRoute === 'home' ? moduleRouteMappings['home'].toLowerCase() : moduleNameFromRoute;

const isValidModule = (moduleFromRoute: string) =>
  moduleNameToEnum(moduleFromRoute) !== ModuleEnum.Unknown;

export const useModuleValidation = () => {
  const permissionsMatrix = useModuleRouter();

  return useCallback(
    (moduleNameFromRoute: string) => {
      moduleNameFromRoute = moduleNameFromRoute.toLowerCase();

      if (!isValidModule(moduleNameFromRoute)) return false;

      const permissionsMatrixWithSpecialRoutes = [
        ...permissionsMatrix,
        ...PERMISSIONS_SPECIAL_MODULES,
      ];

      const moduleName = getModuleName(moduleNameFromRoute);

      return permissionsMatrixWithSpecialRoutes.some(
        (specialRoute) => specialRoute.toLowerCase() === moduleName
      );
    },
    [permissionsMatrix]
  );
};
